@if (open) {
  <div class="cd-backdrop" (click)="!busy && cancel.emit()">
    <div
      class="cd"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="cd-title"
      aria-describedby="cd-message"
      (click)="$event.stopPropagation()">
      <h3 id="cd-title" class="cd-title">{{ title }}</h3>
      <p id="cd-message" class="cd-message">{{ message }}</p>
      <div class="cd-actions">
        <button type="button" class="cd-cancel" #cancelButton [disabled]="busy" (click)="cancel.emit()">Cancel</button>
        <button type="button" class="cd-confirm" [disabled]="busy" (click)="confirm.emit()">
          {{ busy ? busyLabel : confirmLabel }}
        </button>
      </div>
    </div>
  </div>
}
